import * as _ from 'lodash';
import { Chart } from './chart.interface';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { RankingServiceProvider } from '../../../modules/ranking/services/ranking-service/ranking-service';
import { take } from 'rxjs/operators';
import { User, UsersServiceProvider } from './../../../modules/core/services/users-service/users-service';

@Component({
  selector: 'sellions-chart',
  templateUrl: 'sellions-chart.html',
})
export class SellionsChartComponent implements OnInit {
  @Input() chartLabels: string[];
  @Input() chartHighlights: boolean[];
  @Input() chartValues: number[];
  @Input() groupIds: string[];
  @Input() rankDef: number[];
  @Input() player: User;

  public ranking = [];
  public usersInGroup: any[] = []; // todo: make/find and interface for this
  public charts: Array<Chart> = [];

  constructor(public modalCtrl: ModalController, private userService: UsersServiceProvider, private rankingService: RankingServiceProvider) {}

  ngOnInit() {
    this.loadRankings();
    this.createCharts();
    this.sortCharts();
  }

  private loadRankings() {
    this.rankingService
      .loadRankings()
      .pipe(take(1))
      .subscribe((rankingsMap) => {
        const key = this.rankDef[0].toString();
        this.ranking = rankingsMap[key];
      });
  }

  private createCharts() {
    for (let i = 0; i < this.chartValues.length; i++) {
      this.charts.push({
        label: this.chartLabels[i],
        highlights: this.chartHighlights[i],
        values: this.chartValues[i],
        groupIds: this.groupIds[i],
        rankDef: this.rankDef[i],
      });
    }
  }

  private sortCharts() {
    this.charts.sort((a, b) => {
      if (a.values > b.values) return -1;
      if (a.values < b.values) return 1;
      return 0;
    });
  }

  public getFillWidth(value: number) {
    return (value / this.getMaximumValue()) * 95 + '%';
  }

  public getMaximumValue() {
    let maximum = Math.max(...this.chartValues);
    if (maximum !== 0) return maximum;
    return 1;
  }

  public showUserList(chart: Chart) {
    let rankingPerUser = this.createRankingPerUser(chart);
    this.populateUsersInGroup(rankingPerUser);
    this.showModalWithDetails(this.usersInGroup, chart);
  }

  // todo: create an interface for ranking
  private createRankingPerUser(chart: Chart) {
    console.log({ ranking: this.ranking });
    const groupIds = chart.groupIds;
    return _.groupBy(this.ranking[groupIds][0].params.kpis, 'userId');
  }

  private populateUsersInGroup(rankingPerUser) {
    this.usersInGroup = [];

    // todo: what type is totalScore? is this the best name for the variable?
    let totalScore: any;
    const users = this.userService.getUsersProperty();
    console.log({ users });
    for (let userId in rankingPerUser) {
      console.log({ userId });
      // todo: a and b should be typed
      totalScore = rankingPerUser[userId].reduce((a, b) => ({ value: a.value + b.value }));
      this.usersInGroup.push({
        id: userId,
        firstName: users[userId] ? users[userId].firstName : '',
        lastName: users[userId] ? users[userId].lastName : '',
        value: totalScore.value,
      });
    }
  }

  public async showModalWithDetails(usersInGroup, chart: Chart) {
    let modal = this.modalCtrl.create('RegionsUsersDetailsComponent', {
      usersInGroup: usersInGroup,
      chart: chart.label,
      player: this.player,
    });
    modal.present().catch((err) => console.error(err));
    modal.onDidDismiss(() => (this.usersInGroup = []));
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-chart/sellions-chart.ts